import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import credit from './modules/credit';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    credit
  },
  strict: process.env.NODE_ENV !== 'production'
});